import Checkbox from '@mui/material/Checkbox';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

export default function CheckBoxRadio({ name, checked, onCheck }) {
  return (
    <Checkbox
      icon={<CheckCircleIcon />}
      checkedIcon={<CheckCircleIcon color="success" />}
      checked={checked}
      onChange={onCheck}
      inputProps={{ 'aria-label': name }}
      sx={{
        p: 0, // remove padding
        m: 0, // remove margin
        verticalAlign: 'middle',
      }}
    />
  );
}
